import { axiosClient } from "../../../config/axios";

export const resetPasswordApi = async ({ token, payload }) => {
  const res = await axiosClient(`/password/reset/${token}`, payload);
  return res;
};
